import DotNetObject = DotNet.DotNetObject;
import { PermissionJobGroup } from '@crimsontide/core/client/interfaces';

export const PermissionJobGroupService = (() => {
  let dotNetObj: DotNetObject;
  let cachedPermissionJobGroups: PermissionJobGroup[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getPermissionJobGroups = async (useCache: boolean = true): Promise<PermissionJobGroup[]> => {
    if (useCache && cachedPermissionJobGroups != null)
      return cachedPermissionJobGroups;

    if (dotNetObj) {
      cachedPermissionJobGroups = await dotNetObj.invokeMethodAsync<PermissionJobGroup[]>('GetPermissionJobGroupsAsync');
      return cachedPermissionJobGroups;
    } else {
      throw 'PermissionJobGroupService DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getPermissionJobGroups,
  };
})();
